/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { MarkerPointOut } from './markerPointOut';
import type { MarkersOutUnavailableCode } from './markersOutUnavailableCode';
import type { MarkerSpanOut } from './markerSpanOut';

export interface MarkersOut {
  version?: number;
  duration_ms: number | null;
  truncated_at_ms: number | null;
  unavailable_code: MarkersOutUnavailableCode;
  spans: MarkerSpanOut[];
  points: MarkerPointOut[];
}
